import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { Home } from '../../../__legacy__/routes/config/Home';
import { S_Tab, TabsSingleItemState } from '../../../design/tabs/tab/S_Tab';
import { S_TabsContainer } from '../../../design/tabs/tabsContainer/S_TabsContainer';

interface IProps {
  workspaceId: string;
}

export const CloudCostsTabs = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { workspaceId } = props;
  const location = useLocation();

  function getClass(link: string): TabsSingleItemState {
    return matchPath<{ workspaceId: string }>(location.pathname, { path: link }) ? 'active' : 'passive';
  }

  return (
    <S_TabsContainer>
      <S_Tab
        text={t('cloud_costs.history')}
        link={Home.User.CloudCosts.History.withParams({ workspaceId })}
        state={getClass(Home.User.CloudCosts.History.Path)}
      />
    </S_TabsContainer>
  );
});
